module.exports = __webpack_public_path__ + "img/do.dofe8ec4a.svg";